import {
  IEmailBlock,
  IEmailLocaleContent,
} from "../../interfaces/emailTemplate.interface";

export interface EditorBlock {
  id: string;
  block: IEmailBlock;
}

export interface LocaleDraft {
  subject: string;
  blocks: EditorBlock[];
}

export type Drafts = Record<string, LocaleDraft>;

export const EMPTY_DRAFT: LocaleDraft = { subject: "", blocks: [] };

let seq = 0;
export const newBlockId = (): string => `b${(seq += 1)}`;

export const toEditorDraft = (content?: IEmailLocaleContent): LocaleDraft => ({
  subject: content?.subject ?? "",
  blocks: (content?.blocks ?? []).map((block) => ({ id: newBlockId(), block })),
});

export const toContent = (draft: LocaleDraft): IEmailLocaleContent => ({
  subject: draft.subject,
  blocks: draft.blocks.map((entry) => entry.block),
});
